import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ShopTopAction from "../../components/product/ShopTopAction";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const ShopTopbar = ({
  getLayout,
  setSort,
  getFilterSortParams,
  productCount,
  sortedProductCount,
}) => {
  const { i18next } = useTranslation();
  useEffect(() => {}, [i18next]);
  return (
    <Fragment>
      {/* shop top action */}
      <ShopTopAction
        setSort={setSort}
        getLayout={getLayout}
        getFilterSortParams={getFilterSortParams}
        productCount={productCount}
        sortedProductCount={sortedProductCount}
      />
    </Fragment>
  );
};

ShopTopbar.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopbar;
